export const navigation = [
  {
    text: 'Home',
    path: '/home',
    icon: 'assets/Web Icon/Black/home.png',
    icon_white: 'assets/Web Icon/Transparent/home.png',
    icon_trans: 'assets/Web Icon/primary/home.png',
    type: 'WP',
    visible: true
  },
  {
    text: 'Home',
    path: '/ESS-Home',
    icon: 'assets/Web Icon/Black/home2.png',
    icon_white: 'assets/Web Icon/Transparent/home2.png',
    icon_trans: 'assets/Web Icon/primary/home2.png',
    type: 'ESS',
    visible: true
  },
  {
    text: 'Requirement List',
    path: '/Requirements',
    icon: 'assets/Web Icon/Black/ic_playlist_add_24px.png',
    icon_white: 'assets/Web Icon/Transparent/ic_playlist_add_24px.png',
    icon_trans: 'assets/Web Icon/primary/ic_playlist_add_24px.png',
    type: 'ESS',
    visible: true
  },
  // {
  //   text: 'Letter Acceptance',
  //   path: '/Offer-Acceptance',
  //   icon: 'assets/Web Icon/Black/ic_playlist_add_check_24px.png',
  //   icon_white: 'assets/Web Icon/Transparent/ic_playlist_add_check_24px.png',
  //   icon_trans: 'assets/Web Icon/primary/ic_playlist_add_check_24px.png',
  //   type: 'ESS',
  //   visible: true
  // }, 
  {
    text: 'Me',
    path: '/My-Details',
    icon: 'assets/Web Icon/Black/Vector.png',
    icon_white: 'assets/Web Icon/Transparent/Vector.png',
    icon_trans: 'assets/Web Icon/primary/Vector.png',
    type: 'ESS',
    visible: true
  },
  {
    text: 'Financials',
    path: '/Financials',
    icon: 'assets/Web Icon/Black/currency_rupee.png',
    icon_white: 'assets/Web Icon/Transparent/currency_rupee.png',
    icon_trans: 'assets/Web Icon/primary/currency_rupee.png',
    type: 'ESS',
    visible: true
  },
  {
    text: 'HR Activities',
    path: '/HR-Activities',
    icon: 'assets/Web Icon/Black/perm_contact_calendar.png',
    icon_white: 'assets/Web Icon/Transparent/perm_contact_calendar.png',
    icon_trans: 'assets/Web Icon/primary/perm_contact_calendar.png',
    type: 'ESS',
    visible: true
  },
  {
    text: 'Asset Details',
    path: '/Assets',
    icon: 'assets/Web Icon/Black/web_asset.png',
    icon_white: 'assets/Web Icon/Transparent/web_asset.png',
    icon_trans: 'assets/Web Icon/primary/web_asset.png',
    type: 'ESS',
    visible: true
  },
    {
    text: 'My Hierarchy',
    path: '/Team-Members',
    icon: 'assets/Web Icon/Black/Team Members.png',
    icon_white: 'assets/Web Icon/Transparent/Team Members.png',
    icon_trans: 'assets/Web Icon/primary/Team Members.png',
    type: 'ESS',
    visible: true
  },
  {
    text: 'Employee Directory',
    path: '/Employee-Directory',
    icon: 'assets/Web Icon/Black/person_search.png',
    icon_white: 'assets/Web Icon/Transparent/person_search.png',
    icon_trans: 'assets/Web Icon/primary/person_search.png',
    type: 'ESS',
    visible: true
  },

  {
    text: 'FAQ',
    path: '/FAQ-Template',
    icon: 'assets/Web Icon/Black/faq.png',
    icon_white: 'assets/Web Icon/Transparent/faq.png',
    icon_trans: 'assets/Web Icon/primary/faq.png',
    type: 'ESS',
    visible: true
  },
  {
    text: 'Social',
    path: '/Social',
    icon: 'assets/Web Icon/Black/User Photo.png',
    icon_white: 'assets/Web Icon/Transparent/User Photo.png',
    icon_trans: 'assets/Web Icon/primary/User Photo.png',
    type: 'ESS',
    visible: true
  },
  // {
  //   text: 'Service Request',
  //   path: '/My-Queries',
  //   icon: 'assets/Web Icon/Black/manage_accounts.png',
  //   icon_white: 'assets/Web Icon/Transparent/manage_accounts.png',
  //   icon_trans: 'assets/Web Icon/primary/manage_accounts.png',
  //   type: 'ESS',
  //   visible: true
  // }, 
  // {
  //   text: 'Letter Acceptance',
  //   path: '/Offer-Acceptance',
  //   icon: 'assets/Web Icon/Black/ic_playlist_add_check_24px.png',
  //   icon_white: 'assets/Web Icon/Transparent/ic_playlist_add_check_24px.png',
  //   icon_trans: 'assets/Web Icon/primary/ic_playlist_add_check_24px.png',
  //   type: 'WP',
  //   visible: true
  // },
  // {
  //   text: 'Personal Details',
  //   path: '/personalinfo',
  //   icon: 'assets/Web Icon/Black/Personal Details.png',
  //   icon_white: 'assets/Web Icon/Transparent/Personal Details.png',
  //   icon_trans: 'assets/Web Icon/primary/Personal Details.png',
  //   type: 'ESS',
  //   visible: true
  // },
  // {
  //   text: 'Skill Details',
  //   icon: 'assets/Web Icon/Black/User Skills.png',
  //   icon_white: 'assets/Web Icon/Transparent/User Skills.png',
  //   icon_trans: 'assets/Web Icon/primary/User Skills.png',
  //   type: 'ESS',
  //   path: '/skill-details',
  //   visible: true
  // },
  {
    text: 'Personal Details',
    path: '/home/Personal-Info',
    icon: 'assets/Web Icon/Black/Personal Details.png',
    icon_white: 'assets/Web Icon/Transparent/Personal Details.png',
    icon_trans: 'assets/Web Icon/primary/Personal Details.png',
    type: 'WP',
    visible: true
  },

  {
    text: 'Profile Photo',
    path: '/home/Profile-Photo',
    icon: 'assets/Web Icon/Black/profile.png',
    icon_white: 'assets/Web Icon/Transparent/profile.png',
    icon_trans: 'assets/Web Icon/primary/profile.png',
    type: 'WP',
    visible: true
  },

  {
    text: 'Skill Details',
    icon: 'assets/Web Icon/Black/User Skills.png',
    icon_white: 'assets/Web Icon/Transparent/User Skills.png',
    icon_trans: 'assets/Web Icon/primary/User Skills.png',
    type: 'WP',
    path: '/home/skill-details',
    visible: true
  },
  {
    text: 'Address Details',
    path: '/home/Address-Info',
    icon: 'assets/Web Icon/Black/User Address.png',
    icon_white: 'assets/Web Icon/Transparent/User Address.png',
    icon_trans: 'assets/Web Icon/primary/User Address.png',
    type: 'WP',
    visible: true
  },
  // {
  //   text: 'Address Details',
  //   path: '/Address-Info',
  //   icon: 'assets/Web Icon/Black/User Address.png',
  //   icon_white: 'assets/Web Icon/Transparent/User Address.png',
  //   icon_trans: 'assets/Web Icon/primary/User Address.png',
  //   type: 'ESS',
  //   visible: true
  // },
  {
    text: 'Family Details',
    path: '/home/Family-info',
    icon: 'assets/Web Icon/Black/User Family.png',
    icon_white: 'assets/Web Icon/Transparent/User Family.png',
    icon_trans: 'assets/Web Icon/primary/User Family.png',
    type: 'WP',
    visible: true
  },
  // {
  //   text: 'Family Details',
  //   path: '/Family-info',
  //   icon: 'assets/Web Icon/Black/User Family.png',
  //   icon_white: 'assets/Web Icon/Transparent/User Family.png',
  //   icon_trans: 'assets/Web Icon/primary/User Family.png',
  //   type: 'ESS',
  //   visible: true
  // },
  {
    text: 'Education Details',
    path: '/home/Education-info',
    icon: 'assets/Web Icon/Black/User Education.png',
    icon_white: 'assets/Web Icon/Transparent/User Education.png',
    icon_trans: 'assets/Web Icon/primary/User Education.png',
    type: 'WP',
    visible: true
  },
  // {
  //   text: 'Education Details',
  //   path: '/Education-info',
  //   icon: 'assets/Web Icon/Black/User Education.png',
  //   icon_white: 'assets/Web Icon/Transparent/User Education.png',
  //   icon_trans: 'assets/Web Icon/primary/User Education.png',
  //   type: 'ESS',
  //   visible: true
  // },
  {
    text: 'Employment Details',
    path: '/home/Employement-info',
    icon: 'assets/Web Icon/Black/User Employment.png',
    icon_white: 'assets/Web Icon/Transparent/User Employment.png',
    icon_trans: 'assets/Web Icon/primary/User Employment.png',
    type: 'WP',
    visible: true
  },
  // {
  //   text: 'Employment Details',
  //   path: '/Employement-info',
  //   icon: 'assets/Web Icon/Black/User Employment.png',
  //   icon_white: 'assets/Web Icon/Transparent/User Employment.png',
  //   icon_trans: 'assets/Web Icon/primary/User Employment.png',
  //   type: 'ESS',
  //   visible: true
  // },
  {
    text: 'Bank Details',
    path: '/home/Bank-Details',
    icon: 'assets/Web Icon/Black/User Bankdetails.png',
    icon_white: 'assets/Web Icon/Transparent/User Bankdetails.png',
    icon_trans: 'assets/Web Icon/primary/User Bankdetails.png',
    type: 'WP',
    visible: true
  },
  // {
  //   text: 'Bank Details',
  //   path: '/Bank-Details',
  //   icon: 'assets/Web Icon/Black/User Bankdetails.png',
  //   icon_white: 'assets/Web Icon/Transparent/User Bankdetails.png',
  //   icon_trans: 'assets/Web Icon/primary/User Bankdetails.png',
  //   type: 'ESS',
  //   visible: true
  // },
  // {
  //   text: 'Salary Details',
  //   path: '/Salary-details',
  //   icon: 'assets/Web Icon/Black/Salary Details.png',
  //   icon_white: 'assets/Web Icon/Transparent/Salary Details.png',
  //   icon_trans: 'assets/Web Icon/primary/Salary Details.png',
  //   type: 'ESS',
  //   visible: true
  // }, {
  //   text: 'My Documents',
  //   path: '/My-Document',
  //   icon: 'assets/Web Icon/Black/ic_folder_open_24px.png',
  //   icon_white: 'assets/Web Icon/Transparent/ic_folder_open_24px.png',
  //   icon_trans: 'assets/Web Icon/primary/ic_folder_open_24px.png',
  //   type: 'ESS',
  //   visible: true
  // },
  // {
  //   text: 'Policy Documents',
  //   path: '/Policy-Documents',
  //   icon: 'assets/Web Icon/Black/ic_folder_open_24px.png',
  //   icon_white: 'assets/Web Icon/Transparent/ic_folder_open_24px.png',
  //   icon_trans: 'assets/Web Icon/primary/ic_folder_open_24px.png',
  //   type: 'ESS',
  //   visible: true
  // },
  // {
  //   text: 'Insurance Details',
  //   path: '/Insurance-Details',
  //   icon: 'assets/Web Icon/Black/Insurance Details.png',
  //   icon_white: 'assets/Web Icon/Transparent/Insurance Details.png',
  //   icon_trans: 'assets/Web Icon/primary/Insurance Details.png',
  //   type: 'ESS',
  //   visible: true
  // }, {
  //   text: 'Assets Details',
  //   path: '/Assets-Details',
  //   icon: 'assets/Web Icon/Black/Asset Details.png',
  //   icon_white: 'assets/Web Icon/Transparent/Asset Details.png',
  //   icon_trans: 'assets/Web Icon/primary/Asset Details.png',
  //   type: 'ESS',
  //   visible: true
  // },

  // {
  //   text: 'Timesheet Submission',
  //   path: '/Timesheet-Submission',
  //   icon: 'assets/Web Icon/Black/Timesheet List.png',
  //   icon_white: 'assets/Web Icon/Transparent/Timesheet List.png',
  //   icon_trans: 'assets/Web Icon/primary/Timesheet List.png',
  //   type: 'ESS',
  //   visible: true
  // },
  // {
  //   text: 'Investment Declaration',
  //   path: '/Investment-Declaration',
  //   icon: 'assets/Web Icon/Black/Investment Info.png',
  //   icon_white: 'assets/Web Icon/Transparent/Investment Info.png',
  //   icon_trans: 'assets/Web Icon/primary/Investment Info.png',
  //   type: 'ESS',
  //   visible: true
  // },

  // {
  //   text: 'Pay Details',
  //   path: '/Pay-Details',
  //   icon: 'assets/Web Icon/Black/User Bankdetails.png',
  //   icon_white: 'assets/Web Icon/Transparent/User Bankdetails.png',
  //   icon_trans: 'assets/Web Icon/primary/User Bankdetails.png',
  //   type: 'ESS',
  //   visible: true
  // },
  // {
  //   text: 'PF Trust',
  //   path: '/PF-Trust',
  //   icon: 'assets/Web Icon/Black/Employment-1.png',
  //   icon_white: 'assets/Web Icon/Transparent/Employment.png',
  //   icon_trans: 'assets/Web Icon/primary/Employment-1.png',
  //   type: 'ESS',
  //   visible: true
  // },
  // {
  //   text: 'Reimbursements',
  //   path: '/Reimbursement-Claim',
  //   icon: 'assets/Web Icon/Black/ic_filter_tilt_shift_24px.png',
  //   icon_white: 'assets/Web Icon/Transparent/ic_filter_tilt_shift_24px.png',
  //   icon_trans: 'assets/Web Icon/primary/ic_filter_tilt_shift_24px.png',
  //   type: 'ESS',
  //   visible: true
  // },
  // {
  //   text: 'Leaves',
  //   path: '/Apply-Leave',
  //   icon: 'assets/Web Icon/Black/Leave List.png',
  //   icon_white: 'assets/Web Icon/Transparent/Leave List.png',
  //   icon_trans: 'assets/Web Icon/primary/Leave List.png',
  //   type: 'ESS',
  //   visible: true
  // },
  // {
  //   text: 'Loan Request',
  //   path: '/Loan-Request',
  //   icon: 'assets/Web Icon/Black/Leave List.png',
  //   icon_white: 'assets/Web Icon/Transparent/Leave List.png',
  //   icon_trans: 'assets/Web Icon/primary/Leave List.png',
  //   type: 'ESS',
  //   visible: true
  // },
  // {
  //   text: 'PMS',
  //   path: '/PMS-Details',
  //   icon: 'assets/Web Icon/Black/PMS Details.png',
  //   icon_white: 'assets/Web Icon/Transparent/PMS Details.png',
  //   icon_trans: 'assets/Web Icon/primary/PMS Details.png',
  //   type: 'ESS',
  //   visible: true
  // },
  // {
  //   text: 'My Approvals',
  //   path: '/My-Approvals',
  //   icon: 'assets/Web Icon/Black/ic_check_box_24px.png',
  //   icon_white: 'assets/Web Icon/Transparent/ic_check_box_24px.png',
  //   icon_trans: 'assets/Web Icon/primary/ic_check_box_24px.png',
  //   type: 'ESS',
  //   visible: true
  // },
  // {
  //   text: 'Notification',
  //   path: '/Notification',
  //   icon: 'assets/Web Icon/Black/ic_check_box_24px.png',
  //   icon_white: 'assets/Web Icon/Transparent/ic_check_box_24px.png',
  //   icon_trans: 'assets/Web Icon/primary/ic_check_box_24px.png',
  //   type: 'ESS',
  //   visible: false
  // },
  {
    text: 'Documentation',
    path: '/home/consultant-documentation',
    icon: 'assets/Web Icon/Black/ic_folder_open_24px.png',
    icon_white: 'assets/Web Icon/Transparent/ic_folder_open_24px.png',
    icon_trans: 'assets/Web Icon/primary/ic_folder_open_24px.png',
    type: 'WP',
    visible: true
  },
  //  {
  //   text: 'Onboarding Details',
  //   path: '/home',
  //   icon: 'assets/Web Icon/Black/OnBoarding.png',
  //   icon_white: 'assets/Web Icon/Transparent/OnBoarding.png',
  //   icon_trans: 'assets/Web Icon/primary/OnBoarding.png',
  //   type: 'ESS',
  //   visible: true
  // },
  // {
  //   text: 'General Declaration',
  //   path: '/General-Declaration',
  //   icon: 'assets/Web Icon/Black/ic_description_24px.png',
  //   icon_white: 'assets/Web Icon/Transparent/ic_description_-1.png',
  //   icon_trans: 'assets/Web Icon/primary/ic_description_-1.png',
  //   type: 'ESS',
  //   visible: true
  // },

  // {
  //   text: 'Attendance Summary',
  //   path: '/Team-Attendance-Summary',
  //   icon: 'assets/Web Icon/Black/ic_view_list_24px.png',
  //   icon_white: 'assets/Web Icon/Transparent/ic_view_list_24px.png',
  //   icon_trans: 'assets/Web Icon/primary/ic_view_list_24px.png',
  //   type: 'ESS',
  //   visible: true
  // },
  // {
  //   text: 'Miss Punch',
  //   path: '/Miss-Punch',
  //   icon: 'assets/Web Icon/Black/miss punch.png',
  //   icon_white: 'assets/Web Icon/Transparent/miss punch.png',
  //   icon_trans: 'assets/Web Icon/primary/miss punch.png',
  //   type: 'ESS',
  //   visible: true
  // }, {
  //   text: 'Team Members Attendance',
  //   path: '/Team-Members-Attendance',
  //   icon: 'assets/Web Icon/Black/Timesheet List.png',
  //   icon_white: 'assets/Web Icon/Transparent/Timesheet List.png',
  //   icon_trans: 'assets/Web Icon/primary/Timesheet List.png',
  //   type: 'ESS',
  //   visible: true
  // }, {
  //   text: 'Comp Off Requests',
  //   path: '/Holiday-Work',
  //   icon: 'assets/Web Icon/Black/Leave Raise.png',
  //   icon_white: 'assets/Web Icon/Transparent/Leave Raise.png',
  //   icon_trans: 'assets/Web Icon/primary/Leave Raise.png',
  //   type: 'ESS',
  //   visible: true
  // }, {
  //   text: 'Attendance Tracker',
  //   path: '/Attendance-Tracker',
  //   icon: 'assets/Web Icon/Black/ic_portrait_24px.png',
  //   icon_white: 'assets/Web Icon/Transparent/ic_portrait_24px.png',
  //   icon_trans: 'assets/Web Icon/primary/ic_portrait_24px.png',
  //   type: 'ESS',
  //   visible: false
  // }, {
  //   text: 'Attendance Correction',
  //   path: '/Attendance-Correction',
  //   icon: 'assets/Web Icon/Black/Approved Timesheet.png',
  //   icon_white: 'assets/Web Icon/Transparent/Approved Timesheet.png',
  //   icon_trans: 'assets/Web Icon/primary/Approved Timesheet.png',
  //   type: 'ESS',
  //   visible: true
  // }, {
  //   text: 'Employee Directory',
  //   path: '/Employee-Directory',
  //   icon: 'assets/Web Icon/Black/ic_folder_shared_24px.png',
  //   icon_white: 'assets/Web Icon/Transparent/ic_folder_shared_24px.png',
  //   icon_trans: 'assets/Web Icon/primary/ic_folder_shared_24px.png',
  //   type: 'ESS',
  //   visible: true
  // },


  // {
  //   text: 'Track Me',
  //   path: '/Track-me',
  //   icon: 'assets/Web Icon/Black/User Address.png',
  //   icon_white: 'assets/Web Icon/Transparent/User Address.png',
  //   icon_trans: 'assets/Web Icon/primary/User Address.png',
  //   type: 'ESS',
  //   visible: true
  // },
  // {
  //   text: 'Product Sales',
  //   path: '/Inventory',
  //   icon: 'assets/Web Icon/Black/inventory.png',
  //   icon_white: 'assets/Web Icon/Transparent/inventory.png',
  //   icon_trans: 'assets/Web Icon/primary/inventory.png',
  //   type: 'ESS',
  //   visible: true
  // },
  // {
  //   text: 'Bill Authorization',
  //   path: '/Bill-Authorization',
  //   icon: 'assets/Web Icon/Black/ic_dashboard_24px.png',
  //   icon_white: 'assets/Web Icon/Transparent/ic_dashboard_24px.png',
  //   icon_trans: 'assets/Web Icon/primary/ic_dashboard_24px.png',
  //   type: 'ESS',
  //   visible: true
  // },
  // {
  //   text: 'Resignation',
  //   path: '/Resignation',
  //   icon: 'assets/Web Icon/Black/resign.png',
  //   icon_white: 'assets/Web Icon/Transparent/resign.png',
  //   icon_trans: 'assets/Web Icon/primary/resign.png',
  //   type: 'ESS',
  //   visible: true
  // },
  // {
  //   text: 'My Service Requests',
  //   path: '/My-Queries',
  //   icon: 'assets/Web Icon/Black/Help.png',
  //   icon_white: 'assets/Web Icon/Transparent/Help.png',
  //   icon_trans: 'assets/Web Icon/primary/Help.png',
  //   type: 'ESS',
  //   visible: true
  // }, {
  //   text: 'References',
  //   path: '/References',
  //   icon: 'assets/Web Icon/Black/reference.png',
  //   icon_white: 'assets/Web Icon/Transparent/reference.png',
  //   icon_trans: 'assets/Web Icon/primary/reference.png',
  //   type: 'ESS',
  //   visible: true
  // },
  {
    text: 'References',
    path: '/home/References',
    icon: 'assets/Web Icon/Black/reference.png',
    icon_white: 'assets/Web Icon/Transparent/reference.png',
    icon_trans: 'assets/Web Icon/primary/reference.png',
    type: 'WP',
    visible: true
  },
  {
    text: 'Onboarding Declaration',
    path: '/home/Onboarding-Declaration',
    icon: 'assets/Web Icon/Black/ob_declare.png',
    icon_white: 'assets/Web Icon/Transparent/ob_declare.png',
    icon_trans: 'assets/Web Icon/primary/ob_declare.png',
    type: 'WP',
    visible: true
  },

  {
    text: 'My Document',
    path: '/My-Document',
    icon: 'assets/Web Icon/Black/my-doc.png',
    icon_white: 'assets/Web Icon/Transparent/my-doc.png',
    icon_trans: 'assets/Web Icon/primary/my-doc.png',
    type: 'WP',
    visible: true
  },

  {
    text: 'Help',
    path: '/My-Queries',
    icon: 'assets/Web Icon/Black/Help.png',
    icon_white: 'assets/Web Icon/Transparent/Help.png',
    icon_trans: 'assets/Web Icon/primary/Help.png',
    type: 'WP',
    visible: true
  }

  /* ,
  {

    text: 'Examples',
    icon: 'folder',
    icon_white: 'folder',
    Transparent [
      {
        text: 'Profile',
        path: '/profile'
      },
      {
        text: 'Display Data',
        path: '/display-data'
      }
    ]
  } */
];
